export const NA_LABEL = "N/A";

export function formatMetricNumber(
  value: number | null | undefined,
  formatter?: (n: number) => string,
): string {
  if (value === null || value === undefined) return NA_LABEL;
  if (Number.isNaN(value)) return NA_LABEL;
  if (formatter) return formatter(value);
  return value.toLocaleString();
}

// For aggregate/summary totals (e.g. "AGR 256K/mo") -- not for individual
// keyword-row values, which should stay precise. Pass as formatMetricNumber's
// `formatter` argument.
export function formatCompactNumber(value: number): string {
  if (value >= 1000000) return (value / 1000000).toFixed(1) + "M";
  if (value >= 1000) return Math.round(value / 1000) + "K";
  return value.toString();
}

export function compareNullableNumber(
  a: number | null | undefined,
  b: number | null | undefined,
  direction: "asc" | "desc",
): number {
  const aNull = a === null || a === undefined || (typeof a === "number" && Number.isNaN(a));
  const bNull = b === null || b === undefined || (typeof b === "number" && Number.isNaN(b));
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;
  const cmp = (a as number) - (b as number);
  return direction === "asc" ? cmp : -cmp;
}
